import { BreadcrumbItem, DynamicParam } from "./components/Breadcrumbs";

/**
 * parses a react-router path and identifies the location of dynamic params
 * Used to help replace the placeholder slugs with the actual name properties of the Models the slugs represent
 *
 * example:
 * pathToDynamicParams("/:organizationId/:appId/", { appId: "custom-app-1", organizationId: "Custom-App-Org" })
 * returns:
 * {
 *   app: {
 *     index: 0,
 *     stateRef: "app"
 *   },
 *   organization: {
 *     index: 1,
 *     stateRef: "organization"
 *   }
 * }
 *
 * @param path - derived from route component `match.path` prop
 * @param params - derived from route component `match.params` prop
 */
export function pathToDynamicParams(path: string, params: any): { [key: string]: DynamicParam } {
    const splitPath = path.split("/").filter(path => path !== "");
    const dynamicParams: { [key: string]: DynamicParam } = {};

    Object.keys(params).map(param => {
        // worth noting:
        // all dynamic params currently in use in the app are suffixed with "Id"
        // if that pattern is broken, this will need to be updated
        const paramKey = param.replace("Id", "");

        dynamicParams[paramKey] = {
            index: splitPath.indexOf(`:${param}`),
            stateRef: paramKey
        };
    });

    return dynamicParams;
}

/**
 * takes a relative url and returns an array of BreadcrumbItems
 * since we may not yet have all of the data from Redux,
 * uses the slugs as placeholder data
 *
 * example: urlToBreadcrumbs("/Custom-App-Org/custom-app-1/intents")
 * returns:
 * [
 *   { label: "Custom-App-Org", path: "/Custom-App-Org" },
 *   { label: "Custom-app-1", path: "/Custom-App-Org/custom-app-1" },
 *   { label: "Intents", path: "/Custom-App-Org/custom-app-1/intents" }
 * ]
 *
 *
 * @param url - derived from route component `match.url` prop
 *
 */
export function urlToBreadcrumbs(url: string): BreadcrumbItem[] {
    const splitPath = url.split("/").filter(path => path !== "");
    const breadcrumbs: BreadcrumbItem[] = [];

    splitPath.map((path, i, paths) => {
        // Split the path by hyphens
        const words = path.split("-");
        let label = "";
        words.forEach(word => {
            label += `${word.substr(0, 1).toUpperCase()}${word.substr(1)} `;
        });
        // trim trailing spaces
        label = label.trim();

        const newCrumb: BreadcrumbItem = { label };

        if (i + 1 !== paths.length) {
            newCrumb.path = `/${paths.slice(0, i + 1).join("/")}`;
        }

        breadcrumbs.push(newCrumb);
    });

    return breadcrumbs;
}
